import React, { useRef,useEffect } from "react";
import gsap, { Power3 } from "gsap";
import "./Home.css";
import FloatedIcons from './FloatedIcons'
import Header from "./Header";
import Gallary from './Gallary'
import Visit from "./Visit";
import Explore from './Pages/Explore'
import Footer from "./Footer";

import SheerBagh from '../img/sheer bagh urdu.png'
import img1 from "../img/discover images/BWP ZOO WEB ICON Lion house CY.png";
import img2 from "../img/discover images/BWP ZOO WEB ICON parrot house CY.png";
import img3 from "../img/discover images/BWP ZOO WEB ICON deer house CY.png";
import img4 from "../img/discover images/BWP ZOO WEB ICON bear house CY.png";
import img5 from "../img/discover images/BWP ZOO WEB ICON peacock house CY.png";
import img6 from "../img/discover images/BWP ZOO WEB ICON monkey house CY.png";
import img7 from "../img/discover images/BWP ZOO WEB ICON museum CY.png";
import img8 from "../img/discover images/BWP ZOO WEB ICON aquarium CY.png";
import img9 from "../img/discover images/BWP ZOO WEB ICON aviary CY.png";

export default function Home() {
  let discoverRef = useRef(null);
  let contentRef = useRef(null);

  useEffect(() => {
    gsap.from(contentRef, {
      duration: 2,
      opacity: 0,
      ease: Power3.easeInOut,
    });
  });

  return (
    <div className="home" id="home">
      <Header />
      <FloatedIcons />
      {/* ----------------------------/////////////////////////INTRO-SECTION */}
      <section className="upper-body">
        <div className="container">
          <div className="content" ref={(el) => (contentRef = el)}>
            <img src={SheerBagh} alt="sheer bag" style={{ width: "200px" }} />
            <p>
              Bahawalpur zoo was set up in 1942 by the former Ameer of
              Bahawalpur, Sir Nawab Sadiq Muhammad Khan Abbasi. It was then
              named "Sher Bagh" (meaning "lion garden").
            </p>
            <button
              type="button"
              onClick={() =>
                discoverRef.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                })
              }
            >
              Discover
            </button>
          </div>
          <div className="contact">
            <div className="text">
              <h3>Contact Information</h3>
              <p>Location : Stadium Road, Old City Bahawalpur, Punjab</p>
              <p>Phone : (062) 9255334</p>
              <p>Opening hours : 9:00 AM - 5:00 PM</p>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="scroll-button"
          onClick={() =>
            discoverRef.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest",
            })
          }
        >
          Scroll <br /> Down
        </button>
      </section>

      {/* ----------------------------/////////////////////////////DISCOVER-SECTION */}
      <section className="discover-section" ref={(el) => (discoverRef = el)}>
        <h1>Highlights at Zoo</h1>
        <div className="content">
          <img src={img1} alt="discover-img" />
          <img src={img2} alt="discover-img" />
          <img src={img3} alt="discover-img" />
          <img src={img4} alt="discover-img" />
          <img src={img5} alt="discover-img" />
          <img src={img6} alt="discover-img" />
          <img src={img7} alt="discover-img" />
          <img src={img8} alt="discover-img" />
          <img src={img9} alt="discover-img" className="last-discover"/>
        </div>
      </section>
      
      {/* -------------------------//////////////////////PLAN YOUR VISIT */}
      <Visit />
      
      {/* -------------------------//////////////////////////////GALLERY */}
      <Gallary />
      {/* -------------------------//////////////////////////////EXPLORE */}
      <Explore/>
      {/* ----------------------------////////////////////FOOTER-SECTION */}
      <Footer />
    </div>
  );
}
